import BookPage from './BookPage';
export default BookPage;
